import _ from 'lodash';

export const models = {
    School: ['$resource', $resource => {
        let floatLoader = value => parseFloat(value || 0);

        return $resource({
            url: `${API_URL}/school/`,
            actions: {
                'query': {method: 'GET', isArray: true}
            },
            fields: {
                id: {avoidDump: true},
                name: {avoidDump: true},
                address: {avoidDump: true},
                city: {avoidDump: true},
                state: {avoidDump: true},
                postcode: {avoidDump: true},
                country: {avoidDump: true},
                email: {avoidDump: true},
                phone: {avoidDump: true},
                latitude: {loader: floatLoader},
                longitude: {loader: floatLoader}
            }
        });
    }],

    Lead: [
        '$resource',
        'phoneValidator',
        'phoneProcessor',
        'dateProcessor',
        ($resource, phoneValidator, phoneProcessor, dateProcessor) => {
            return $resource({
                url: `${API_URL}/lead/:leadId`,
                paramDefaults: {leadId: '@id'},
                fields: {
                    full_name: {validators: ['notNull']},
                    email: {validators: ['notNull', 'email', {maxLength: [254]}]},
                    primary_phone: _.assign({validators: [phoneValidator]}, phoneProcessor),
                    origin: true,
                    lead_type: true,
                    allow_communication: true,
                    school: {resource: 'School'},
                    country: true
                }
            });
        }
    ]
};



// WEBPACK FOOTER //
// ./scripts/models.js